import RecordsTableCard from "./RecordsTableCard";
import { getTomDisplayId, getTomId } from "../../../../toms/utils/tomIdentifiers";

const RevisionWidget = ({ title, data = {}, t, isFetching, tooltipText }) => {
  const rows = (data?.toms || []).map((item) => ({
    tom: getTomId(item),
    displayId: getTomDisplayId(item),
    title: item.title ?? item.name,
  }));

  return (
    <RecordsTableCard
      t={t}
      title={title}
      tooltipText={tooltipText}
      data={rows}
      type="tom"
      isFetching={isFetching}
    />
  );
};

export default RevisionWidget;
